import ApiRequest from './ApiRequest'

class PageableApiRequest extends ApiRequest {
  constructor (requestFn, Model, options) {
    super(requestFn, Model, options)

    this.data = []
    this.total = 0
    this.page = 1
    this.pageCount = 0
    this.pageSize = 0
  }

  parsePayload (payload) {
    return this.Model != null ? payload.map(data => new this.Model(data)) : payload
  }

  parsePageInfo (pageInfo) {
    if (pageInfo != null) {
      return {
        total: pageInfo.totalCount,
        page: pageInfo.pageIndex + 1,
        pageCount: pageInfo.totalPageCount,
        pageSize: pageInfo.pageSize
      }
    }
  }

  setData (data) {
    this.data = data
  }

  setPagination (pagination) {
    Object.assign(this, pagination)
  }

  clearData () {
    this.setData([])
  }

  handleResponse ({ payload, pageInfo }) {
    this.setData(this.parsePayload(payload))
    this.setPagination(this.parsePageInfo(pageInfo))
    this.setLoading(false)

    return this.data
  }
}

export default PageableApiRequest
